export enum ReconciliationDownloadModal {
  ListOfBankAccounts = 'list of bank accounts',
  ClosesByAccount = 'closes by account',
  AccountCloseDetails = 'account close details',
}
